jQuery(function($) {
  $( document ).ready(function() {
    
    $('.type-product-grid-item .add-to-cart').on('click', function(e){
      e.preventDefault();
      var formID = $(this).data("productformid");
      console.log(formID);
      $.ajax({
        type: 'POST', 
        url: '/cart/add.js',
        dataType: 'json', 
        data: $('#'+formID).serialize(),
        success: function(data) {
          
          document.body.dispatchEvent(new CustomEvent('baseline:modalcart:updatequantity'));
          
          Spruce.store('drawer').cartDrawerOpen = true;
          
        },
		error: function(data) { 
          alert("The product you are trying to add is out of stock."); 
        } 
      });
    });

  });
});



  $(document).ready(function() {
    $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
      console.log($(this).is('#cart-drawer-submit'));
      
      if($(this).is('#cart-drawer-submit')){    
        if ($('#cart-drawer-agree').is(':checked')) {
          $(this).submit();
        }
        else {
          alert("ARE YOU OVER 18?\r\nNo alcohol can be sold or supplied to anyone under 18. It’s against the law.");
          return false;
        }
      }
      
      if($(this).is('#cart-page-submit')){    
        if ($('#cart-page-agree').is(':checked')) {
          $(this).submit();
        }
        else {
          alert("ARE YOU OVER 18?\r\nNo alcohol can be sold or supplied to anyone under 18. It’s against the law.");
          return false;
        }
      }
    });
  });
  
